/**
 * WhatsApp utility
 * PROTEGE QV Lecture+ — Build and open pre-filled WhatsApp URLs
 */

/**
 * Open a WhatsApp conversation with a pre-filled message.
 * @param {string} phone  Phone number in international format without + (e.g. "237699936028")
 * @param {string} message  Plain-text message to pre-fill
 */
export const openWhatsApp = (phone, message) => {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
